export class Helper {
    constructor() {
        this.needsGlobal = false;
        this.needsGlobalOut = false;
    }
    emitGlobal(_sb, _node, _options) {
    }
    emitGlobalOut(_sb, _node, _options) {
    }
}

//# sourceMappingURL=Helper.js.map
